import { WidgetResultType } from "@akinon/next/types";
import { HeaderBandType } from "./band";
import { HeaderBandLink } from "./header-bank-link";

export const MobileBandMenu = ({bandWidget}: {bandWidget: WidgetResultType<HeaderBandType>}) => {
  return (
    <div className="px-4 pt-12 pb-6">
      {bandWidget && (
        <ul className="flex flex-col space-y-6 text-gray text-xs">
          {bandWidget?.attributes?.menu?.map((x, index) => (
            <li key={index}>
              <HeaderBandLink key={x.value.text} link={x} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
